export default "__VITE_ASSET__A4RTqTQ$__"